import { cn } from '../../lib/utils';
import { icons } from './Icons';

export function ErrorState({ title = 'Daten konnten nicht geladen werden', description, onRetry, className }: { title?: string; description?: string; onRetry?: () => void; className?: string }) {
  return (
    <div className={cn('flex min-h-[180px] flex-col items-center justify-center px-6 py-8 text-center', className)}>
      <div className="flex h-11 w-11 items-center justify-center rounded-lg bg-danger-100 text-danger-700 dark:bg-danger-900/30 dark:text-danger-300">
        <icons.AlertCircle className="h-5 w-5" aria-hidden="true" />
      </div>
      <h3 className="mt-4 text-h3 font-semibold text-neutral-900 dark:text-neutral-100">{title}</h3>
      {description && <p className="mt-1 max-w-md text-body text-neutral-600 dark:text-neutral-300">{description}</p>}
      {onRetry && (
        <button type="button" onClick={onRetry} className="mt-5 inline-flex items-center gap-2 rounded-md border border-neutral-300 bg-white px-3 py-2 text-sm font-medium text-neutral-700 hover:bg-neutral-50 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 dark:border-neutral-600 dark:bg-neutral-800 dark:text-neutral-200 dark:hover:bg-neutral-700">
          <icons.RefreshCw className="h-4 w-4" aria-hidden="true" />
          Erneut versuchen
        </button>
      )}
    </div>
  );
}
